var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("FixedTermCampaignExcelModal", {
        on: { success: _vm.successExcelImport }
      }),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "FixedTermCampaign" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: { type: "number", toggle: "" },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.fixedTermCampaign.title"),
                    active: ""
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CampaignBeginDate",
                            error: _vm.$v.form.CampaignBeginDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            model: {
                              value: _vm.form.CampaignBeginDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "CampaignBeginDate", $$v)
                              },
                              expression: "form.CampaignBeginDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CampaignEndDate",
                            error: _vm.$v.form.CampaignEndDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            model: {
                              value: _vm.form.CampaignEndDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "CampaignEndDate", $$v)
                              },
                              expression: "form.CampaignEndDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "UseBudget",
                            error: _vm.$v.form.UseBudget
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: { type: "number", toggle: "" },
                            model: {
                              value: _vm.form.UseBudget,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "UseBudget", $$v)
                              },
                              expression: "form.UseBudget"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BudgetAmount",
                            error: _vm.$v.form.BudgetAmount
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.form.UseBudget !== 1
                            },
                            model: {
                              value: _vm.form.BudgetAmount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "BudgetAmount", $$v)
                              },
                              expression: "form.BudgetAmount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "UsedAmount",
                            error: _vm.$v.form.UsedAmount
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number", disabled: true },
                            model: {
                              value: _vm.form.UsedAmount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "UsedAmount", $$v)
                              },
                              expression: "form.UsedAmount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RouteCriteriaId",
                            error: _vm.$v.form.RouteCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.RouteCriteriaId,
                              label: "Label",
                              "lookup-key": "ROUTE_CRITERIA"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "RouteCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedRouteCriteria,
                              callback: function($$v) {
                                _vm.selectedRouteCriteria = $$v
                              },
                              expression: "selectedRouteCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerCriteriaId",
                            error: _vm.$v.form.CustomerCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.CustomerCriteriaId,
                              label: "Label",
                              source: _vm.lookup.CUSTOMER_CRITERIA
                                ? _vm.lookup.CUSTOMER_CRITERIA.filter(function(
                                    c
                                  ) {
                                    return (
                                      c.Code == "MK" ||
                                      c.Code === "ML" ||
                                      c.Code === "TM"
                                    )
                                  })
                                : []
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "CustomerCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedCustomerCriteria,
                              callback: function($$v) {
                                _vm.selectedCustomerCriteria = $$v
                              },
                              expression: "selectedCustomerCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ItemCriteriaId",
                            error: _vm.$v.form.ItemCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.ItemCriteriaId,
                              source: _vm.lookup.ITEM_CRITERIA
                                ? _vm.lookup.ITEM_CRITERIA.filter(function(i) {
                                    return i.Code != "UL"
                                  })
                                : [],
                              label: "Label"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "ItemCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedItemCriteria,
                              callback: function($$v) {
                                _vm.selectedItemCriteria = $$v
                              },
                              expression: "selectedItemCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BranchCriteriaId",
                            error: _vm.$v.form.BranchCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "BRANCH_CRITERIA",
                              disabled: _vm.insertReadonly.BranchCriteriaId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "BranchCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedBranchCriteria,
                              callback: function($$v) {
                                _vm.selectedBranchCriteria = $$v
                              },
                              expression: "selectedBranchCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CampaignTypeId",
                            error: _vm.$v.form.CampaignTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextDiscount/api/DiscountType/Search"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "CampaignTypeId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CampaignRate",
                            error: _vm.$v.form.CampaignRate
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              readonly: _vm.insertReadonly.CampaignRate
                            },
                            model: {
                              value: _vm.form.CampaignRate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "CampaignRate", $$v)
                              },
                              expression: "form.CampaignRate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CurrencyId",
                            error: _vm.$v.form.CurrencyId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: !_vm.form.UseBudget,
                              label: "Description1",
                              url: "VisionNextSystem/api/SysCurrency/Search"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "CurrencyId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.fixedTermCampaign.maturityPeriods")
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.fixedTermCampaign.startQuantity"
                            ),
                            error: _vm.$v.fixedTermCampaignTaken.startQuantity,
                            required: true
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.fixedTermCampaignTaken.startQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.fixedTermCampaignTaken,
                                  "startQuantity",
                                  $$v
                                )
                              },
                              expression: "fixedTermCampaignTaken.startQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.fixedTermCampaign.endQuantity"
                            ),
                            error: _vm.$v.fixedTermCampaignTaken.endQuantity,
                            required: true
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.fixedTermCampaignTaken.endQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.fixedTermCampaignTaken,
                                  "endQuantity",
                                  $$v
                                )
                              },
                              expression: "fixedTermCampaignTaken.endQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.fixedTermCampaign.paymentPeriod"
                            ),
                            error: _vm.$v.fixedTermCampaignTaken.paymentPeriod,
                            required: true
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.fixedTermCampaignTaken.paymentPeriod,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.fixedTermCampaignTaken,
                                  "paymentPeriod",
                                  $$v
                                )
                              },
                              expression: "fixedTermCampaignTaken.paymentPeriod"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "text-right",
                          attrs: { cols: "12", md: "2", lg: "2" }
                        },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addFixedTermCampaignTaken($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-table-simple",
                        { attrs: { bordered: "", small: "" } },
                        [
                          _c(
                            "b-thead",
                            [
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "insert.fixedTermCampaign.startQuantity"
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "insert.fixedTermCampaign.endQuantity"
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "insert.fixedTermCampaign.paymentPeriod"
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b-th", [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("list.operations")))
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tbody",
                            _vm._l(_vm.form.FixedTermCampaignTakens, function(
                              f,
                              i
                            ) {
                              return _c(
                                "b-tr",
                                { key: i },
                                [
                                  _c("b-td", [_vm._v(_vm._s(f.StartQuantity))]),
                                  _vm._v(" "),
                                  _c("b-td", [_vm._v(_vm._s(f.EndQuantity))]),
                                  _vm._v(" "),
                                  _c("b-td", [_vm._v(_vm._s(f.PaymentPeriod))]),
                                  _vm._v(" "),
                                  _c("b-td", { staticClass: "text-center" }, [
                                    _c("i", {
                                      staticClass:
                                        "far fa-trash-alt text-danger",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeFixedTermCampaignTaken(
                                            f
                                          )
                                        }
                                      }
                                    })
                                  ])
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectedItemCriteria && _vm.selectedItemCriteria.Code === "UK"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t(
                          "insert.fixedTermCampaign.discountedItems"
                        )
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "insert.fixedTermCampaign.areaDescription"
                                ),
                                error: _vm.$v.campaignItemArea,
                                required: true,
                                md: "5",
                                lg: "5"
                              }
                            },
                            [
                              _c("NextDropdown", {
                                attrs: {
                                  source: _vm.campaignItemAreaList,
                                  label: "Label"
                                },
                                model: {
                                  value: _vm.campaignItemArea,
                                  callback: function($$v) {
                                    _vm.campaignItemArea = $$v
                                  },
                                  expression: "campaignItemArea"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                title: _vm.$t("insert.fixedTermCampaign.value"),
                                error: _vm.$v.campaignItemValue,
                                required: true,
                                md: "5",
                                lg: "5"
                              }
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  options: _vm.campaignItemValueList,
                                  filterable: true,
                                  label: "Label"
                                },
                                model: {
                                  value: _vm.campaignItemValue,
                                  callback: function($$v) {
                                    _vm.campaignItemValue = $$v
                                  },
                                  expression: "campaignItemValue"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "text-right",
                              attrs: { cols: "12", md: "2", lg: "2" }
                            },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("AddDetailButton", {
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.addFixedTermCampaignItem(
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-table-simple",
                            { attrs: { bordered: "", small: "" } },
                            [
                              _c(
                                "b-thead",
                                [
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.fixedTermCampaign.areaDescription"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.fixedTermCampaign.value"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("list.operations")))
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tbody",
                                _vm._l(
                                  _vm.form.FixedTermCampaignItems,
                                  function(f, i) {
                                    return _c(
                                      "b-tr",
                                      { key: i },
                                      [
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(f.ColumnNameDescription)
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(f.ColumnValueDescription)
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "b-td",
                                          { staticClass: "text-center" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "far fa-trash-alt text-danger",
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeFixedTermCampaignItem(
                                                    f
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedRouteCriteria &&
              _vm.selectedRouteCriteria.Code === "RL"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.fixedTermCampaign.routes")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.getFixedTermRouteItems() },
                        model: {
                          value: _vm.form.FixedTermCampaignRoutes,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "FixedTermCampaignRoutes", $$v)
                          },
                          expression: "form.FixedTermCampaignRoutes"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedCustomerCriteria &&
              _vm.selectedCustomerCriteria.Code === "MK"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t(
                          "insert.fixedTermCampaign.customerCriterias"
                        )
                      },
                      on: { click: _vm.getCustomerCriteriaItems }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: {
                          items: _vm.getFixedTermCampaignCustomerCriterias()
                        },
                        model: {
                          value: _vm.form.FixedTermCampaignCustomerCriterias,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "FixedTermCampaignCustomerCriterias",
                              $$v
                            )
                          },
                          expression: "form.FixedTermCampaignCustomerCriterias"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedCustomerCriteria &&
              _vm.selectedCustomerCriteria.Code === "ML"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.fieldAnalysis.customerList"),
                        disabled:
                          _vm.selectedBranchCriteria &&
                          _vm.selectedBranchCriteria.Code === "SL" &&
                          (!_vm.form.FixedTermCampaignBranchs ||
                            _vm.form.FixedTermCampaignBranchs.length === 0)
                      }
                    },
                    [
                      _c(
                        "NextDetailPanel",
                        {
                          attrs: {
                            showEdit: false,
                            showWarning: true,
                            showAddButton: false,
                            items: _vm.getFixedTermCustomerItems()
                          },
                          model: {
                            value: _vm.form.FixedTermCampaignCustomers,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form,
                                "FixedTermCampaignCustomers",
                                $$v
                              )
                            },
                            expression: "form.FixedTermCampaignCustomers"
                          }
                        },
                        [
                          _c(
                            "template",
                            { slot: "grid" },
                            [
                              _c(
                                "div",
                                { attrs: { cols: "12", md: "2" } },
                                [
                                  _c("NextMultipleSelection", {
                                    attrs: {
                                      name: "FixedTermCampaignMultipleCustomer",
                                      "hidden-values": _vm.hiddenValues,
                                      "converted-values":
                                        _vm.customerConvertedValues,
                                      validations: _vm.budgetValidation,
                                      "dynamic-and-condition": {
                                        multipleDynamicAndCondition:
                                          _vm.multipleDynamicAndCondition,
                                        StatusIds: [1]
                                      }
                                    },
                                    model: {
                                      value:
                                        _vm.form.FixedTermCampaignCustomers,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "FixedTermCampaignCustomers",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.FixedTermCampaignCustomers"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "12", md: "2" } },
                                [
                                  _c(
                                    "b-form-group",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          directives: [
                                            {
                                              name: "b-modal",
                                              rawName:
                                                "v-b-modal.fixedTerm-campaign-excel-modal",
                                              modifiers: {
                                                "fixedTerm-campaign-excel-modal": true
                                              }
                                            }
                                          ],
                                          staticClass: "mt-4",
                                          attrs: {
                                            size: "sm",
                                            variant: "success"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-file-pdf"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.creditBudget.uploadExcel"
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedBranchCriteria &&
              _vm.selectedBranchCriteria.Code === "SL"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.fixedTermCampaign.branchs")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.getFixedTermBranches() },
                        model: {
                          value: _vm.form.FixedTermCampaignBranchs,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "FixedTermCampaignBranchs", $$v)
                          },
                          expression: "form.FixedTermCampaignBranchs"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a37871c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a37871c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FixedTermCampaign/insert.vue
// module id = null
// module chunks = 